function copyScreenUrl() {

    /* Get the text field */
    var copyText = document.getElementById("screenUrlDisplay");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");

    /* Alert the copied text */
    //alert("Copied the text: " + copyText.value);

    swal({
        title: " ",
        text: "Screen URL copied to clipboard",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
    });
}
function SetScreenDisplayLink(screenlink) {

    const el = (id) => document.getElementById(id);

    const setVisible = (id, visible) => {
        const e = el(id);
        if (!e) return false;
        e.style.visibility = visible ? "visible" : "hidden";
        return true;
    };

    const setValue = (id, value) => {
        const e = el(id);
        if (!e) return false;
        e.value = value;
        return true;
    };

    const setHtml = (id, html) => {
        const e = el(id);
        if (!e) return false;
        e.innerHTML = html;
        return true;
    };

    const setLink = (id, href) => {
        const a = el(id);
        if (!a) return false;

        // Set both property + attribute (some code reads attribute)
        a.href = href;
        a.setAttribute("href", href);

        // Ensure it *really* opens new tab safely
        a.target = "_blank";
        a.rel = "noopener noreferrer";

        return true;
    };

    // Retry helper (Blazor render timing)
    const retry = (fn, tries = 10, delayMs = 80) => {
        if (fn()) return;
        if (tries <= 0) return;
        setTimeout(() => retry(fn, tries - 1, delayMs), delayMs);
    };

    if (!screenlink) {
        setVisible("screenLinkDisplayDiv", false);
        setVisible("screenLinkAppDisplayDiv", false);
        return;
    }

    setVisible("screenLinkDisplayDiv", true);
    setVisible("screenLinkAppDisplayDiv", true);

    const current = new URL(window.location.href);
    const path = current.pathname || "/";
    const hasAppBase = path === "/app" || path.startsWith("/app/");
    const basePath = hasAppBase ? "/app" : "";

    const mainurl = `${current.origin}${basePath}/s/${encodeURIComponent(screenlink)}`;

    // Update fields
    retry(() => setValue("screenUrlDisplay", mainurl));
    retry(() => setLink("screenMainLink", mainurl));

    retry(() => setHtml("screenUrlDisplayAppUrl", screenlink));
    retry(() => setHtml("screenUrlDisplayAppUrlAndroid", screenlink));

    // Tooltips (only if present)
    const initTippy = (selector, text) => {
        if (typeof tippy !== "function") return;
        if (!document.querySelector(selector)) return;

        setTimeout(() => {
            tippy(selector, {
                arrow: true,
                content: `<span>${text}</span>`,
                allowHTML: true,
            });
        }, 200);
    };

    initTippy("#screenUrlDisplayApp", "Click to see app information");
    initTippy("#screenMainLink", "Click to open screen in a new tab");
    initTippy("#copyToClipboardNavbarButton", "Click to copy link to the clipboard");
}


async function copyScreenUrl() {
    const input = document.getElementById("screenUrlDisplay");
    if (!input) return;

    const text = (input.value || "").trim();
    if (!text) return;

    try {
        // Modern clipboard API (requires HTTPS or localhost)
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }

        // Fallback (older browsers / non-secure context)
        input.removeAttribute("readonly");   // some browsers need it selectable
        input.select();
        input.setSelectionRange(0, 99999);
        document.execCommand("copy");
        input.setAttribute("readonly", "readonly");
        window.getSelection()?.removeAllRanges?.();
    }
    catch (err) {
        // last fallback
        try {
            input.select();
            document.execCommand("copy");
        } catch { }
    }
}

function openScreenMainLink(e) {
    try {
        // Prefer the rendered value we show the user
        const input = document.getElementById("screenUrlDisplay");
        const urlFromInput = (input?.value || "").trim();

        // Fallback to the anchor href
        const a = document.getElementById("screenMainLink");
        const urlFromAnchor = (a?.getAttribute("href") || a?.href || "").trim();

        const url = urlFromInput || urlFromAnchor;
        if (!url) return false;

        // Explicit open
        window.open(url, "_blank", "noopener,noreferrer");
    }
    catch { }

    // Prevent any SPA/router from trying to handle it
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    return false;
}


function ShowAppPwaInformation() {
    $('#appPwaInfoModal').modal();
}

function SetScreenDisplayTitle(title) {

    document.getElementById('navbarTitleDisplay').innerHTML = title;


}

function closeNav() {

    console.log("hej");

    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnToggleMenuEventShortcut');
    
    $(".rotate-ico").toggleClass("down");

}

function showSideBar() {
    $(".sidebar").removeClass("hidden-sidebar");
    $(".sidebar").addClass("full-size-sidebar");
}


function hideSideBar() {
    $(".sidebar").addClass("hidden-sidebar");
    $(".sidebar").removeClass("full-size-sidebar");
    
}


//system message popover
function initSystemPopover() {
    $(function () {
        var down = false;

        $('#bell').click(function (e) {

            var color = $(this).text();
            if (down) {

                $('#box').css('height', '0px');
                $('#box').css('display', 'none');
                $('#box').css('z-index', 'auto');
                //$('#box').css('opacity', '0');
                down = false;
            } else {

                $('#box').css('height', '480px');
                $('#box').css('display', 'block');
                $('#box').css('z-index', '100');
                //$('#box').css('opacity', '1');
                down = true;

            }

        });
    });
}

    


    //